import { render } from "./NavComp.vue?vue&type=template&id=5c231b5e"
import script from "./NavComp.vue?vue&type=script&lang=js"
export * from "./NavComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__